export interface SubscriptionInterface {
    subscriptionStatus: string;
    subscriptionDetails: {
        isAvailableForSecurityUpdates: boolean;
        isAvailableForFunctionalUpdates: boolean;
        isAvailableForForceUpdates: boolean;
        isSubscribedForSecurityUpdates: boolean;
        isSubscribedForFunctionalUpdates: boolean;
        isSubscribedForForceUpdates: boolean;
    };
    machineNumber: string;
    machineName: string;
}

export interface ModalInterface {
    subscriptionData: SubscriptionInterface;
    modalFormState: boolean;
    modalFormSpinnerGetState: boolean;
    modalFormSpinnerPostState: boolean;
    updatesSubscribed: boolean;
    readMoreLink: string;
    privacyPolicyLink: string;
    tooltipLink: string;
    onFormValidated: (e: any) => void;
    key: string; // this is used to re-render the modal
}
